import urlApi from '../../router/urlApi'
import urlApiV2 from '../../router/urlApiV2'
import { Serialize } from '../../services/serializeFormData'
import { LoadFormData } from '../../services/LoadFormData'
import Vue from 'vue'
import Toast from 'vue-toasted'
import router from '../../router'

const toastOptions = {
  theme: 'none',
  position: 'bottom-center',
  className: 'vuestic-toast',
  iconPack: 'fontawesome',
  duration: 5000
}

Vue.use(Toast, toastOptions)
export default {

  store () {
    let self = this

    self.disableButtons(true)

    Vue.http.post(urlApi + '/turmas', Serialize.toObject('form_turmas')).then((response) => {
      if (response.status === 200) {
        self.launchToast('fa-check', response.data.mensagem)
        self.pageAdicionarAulaTeorica(response.data.dados.id_turma_teorica)
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    }).catch((response) => {
      if (response.status === 422) {
        Object.keys(response.data.errors).forEach(function (key) {
          self.launchToast('fa-warning', response.data.errors[key][0])
        })
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    })
  },

  storeAula () {
    let self = this

    Vue.http.post(urlApi + '/aulas/teoricas', Serialize.toObject('form_aulas')).then((response) => {
      if (response.status === 200) {
        self.launchToast('fa-check', response.data.dados)
        self.pageListarTurmas()
      } else {
        self.launchToast('fa-check', response.data.dados)
      }
      self.disableButtons(false)
    }).catch((response) => {
      if (response.status === 422) {
        Object.keys(response.data.errors).forEach(function (key) {
          self.launchToast('fa-warning', response.data.errors[key][0])
        })
      } else if (response.status === 400) {
        self.launchToast('fa-warning', response.data.mensagem)
        self.launchToast('fa-warning', response.data.dados)
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    })
  },

  update (idTurma) {
    let self = this
    self.disableButtons(true)
    Vue.http.patch(urlApi + '/turmas/' + idTurma, Serialize.toObject('form_turmas')).then((response) => {
      if (response.status === 200) {
        self.launchToast('fa-check', response.data.mensagem)
        self.pageListarTurmas()
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    }).catch((response) => {
      if (response.status === 422) {
        Object.keys(response.data.errors).forEach(function (key) {
          self.launchToast('fa-warning', response.data.errors[key][0])
        })
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    })
  },

  atualizaStatus: function (idTurma, status, callback) {
    let self = this

    Vue.http.patch(urlApi + '/turmas/' + idTurma + '/' + status, []).then(function (response) {
      if (response.data.sucesso) {
        self.launchToast('fa-check', 'Status atualizado!')
      } else {
        self.launchToast('fa-check', 'Erro ao tentar atualizar o status!')
      }
      callback()
    })
  },

  getTurmaById: function (idTurma, callback) {
    Vue.http.get(urlApi + '/turmas/' + idTurma).then(function (response) {
      callback(response)
    })
  },

  pageListarTurmas () {
    router.push({ name: 'listagem-turmas' })
  },

  pageAdicionarAulaTeorica (idTurma) {
    router.push({ name: 'aula-teorica', params: { idTurma: idTurma } })
  },

  paginaEdicao (idTurma) {
    router.push({ name: 'editar-turma', params: { idTurma: idTurma } })
  },

  carregaFormularioDeEdicao (idTurma) {
    Vue.http.get(urlApi + '/turmas/' + idTurma).then((response) => {
      LoadFormData.byIdInputs(response.data.dados)
    })
  },

  carregaFormularioDeAula (idTurma) {
    console.log('teste')
  },

  disableButtons (status) {
    document.getElementById('btn_salvar').disabled = status
    document.getElementById('btn_limpar').disabled = status
  },

  launchToast (icon, msg) {
    Vue.toasted.show(msg, {
      icon: icon,
      position: 'top-right',
      duration: 5000,
      fullWidth: false
    }
    )
  },

  getInstrutores (callback) {
    Vue.http.get(urlApi + '/instrutores').then((response) => {
      callback(response.data)
    })
  },

  getMaterias (callback) {
    Vue.http.get(urlApi + '/materias').then((response) => {
      callback(response.data)
    })
  },

  getPlanos (callback) {
    Vue.http.get(urlApi + '/planos/teoricos').then((response) => {
      callback(response.data)
    })
  },

  getSalas (callback) {
    Vue.http.get(urlApi + '/aulas/salas').then((response) => {
      callback(response.data)
    })
  },
  sendSnapshot (data, callback) {
    Vue.http.post(urlApi + '/presencas/reconhecimento', data).then(function (response) {
      callback(response)
    }).catch(function (err) {
      console.log(err)
      callback(err)
    })
  },
  registrarPresenca () {

  },
  getFeedbacks (data, callback) {
    Vue.http.get(`${urlApiV2}/aulas/teoricas/feedback/avaliacao-aula/${data.turma}`).then(function (response) {
      callback(response.body)
    }).catch(function (err) {
      console.log(err)
      callback(err)
    })
  },
}
